import React from "react";
import { Flex, Box, Text } from "@chakra-ui/react";

function DateRangeFilter({ fromDate, toDate, onFromDateChange, onToDateChange }) {
  const inputs = [
    { label: "From Date", value: fromDate, max: toDate,   onChange: onFromDateChange },
    { label: "To Date",   value: toDate,   min: fromDate, onChange: onToDateChange  },
  ];
 
  return (
    <Flex alignItems="center" gap={4} flexWrap="wrap">
      {inputs.map(({ label, value, min, max, onChange }) => (
        <Box key={label} minW="210px">
          <Text fontSize="md" color="gray.800" fontWeight="bold" mb={1} mx={2}>
            {label}
          </Text>
          <Box
            as="input"
            type="date"
            value={value}
            min={min}
            max={max}
            onChange={(e) => onChange(e.target.value)}
            sx={{
              width: "100%",
              padding: "8px 12px",
              borderRadius: "8px",
              border: "1px solid",
              borderColor: "gray.300",
              bg: "white",
              fontSize: "16px",
              cursor: "pointer",
              "&:focus": {
                outline: "none",
                borderColor: "red.500",
                boxShadow: "0 0 0 3px rgba(244,0,9,0.3)",
              },
            }}
          />
        </Box>
      ))}
    </Flex>
  );
}
 
export default DateRangeFilter;